import { graphql } from '@generated/gql';

export const FETCH_FEE_GRID_NAME = graphql(/** GraphQL */ `
  query feeGridBreadcrumbFetchFeeGridName($feeTierId: ObjectID!) {
    fetchFeeTier(feeTierId: $feeTierId) {
      feeTier {
        name
      }
    }
  }
`);
